<div class="page">
  <div class="page-header">
    <div>
      <h1>{{ 'PARENTS.TITLE' | translate }}</h1>
      <p class="page-subtitle">{{ 'PARENTS.SUBTITLE' | translate }}</p>
    </div>
    <div class="page-actions">
      <div class="print-scope">
        <app-searchable-select
          [(ngModel)]="printScope"
          [options]="printScopeOptions"
          [placeholder]="'PARENTS.PRINT_SCOPE_ALL' | translate"
          [allowEmpty]="false"
          [searchPlaceholder]="searchPlaceholder"
        ></app-searchable-select>
      </div>
      <div class="print-class">
        <app-searchable-select
          [(ngModel)]="selectedClassId"
          [options]="classOptions"
          [placeholder]="allClassesLabel"
          [emptyLabel]="allClassesLabel"
          [searchPlaceholder]="searchPlaceholder"
          [allowEmpty]="true"
          (selectionChange)="onClassChange()"
        ></app-searchable-select>
      </div>
      <div class="print-cards-scope">
        <app-searchable-select
          [(ngModel)]="cardsParentScope"
          [options]="cardsParentScopeOptions"
          [placeholder]="'PARENTS.CARDS_SCOPE_ALL' | translate"
          [allowEmpty]="false"
          [searchPlaceholder]="searchPlaceholder"
        ></app-searchable-select>
      </div>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="printCardsPdf()"
        [disabled]="exporting || !selectedClassId || (!selected.length && !filteredItems.length)"
        [attr.title]="!selectedClassId ? ('PARENTS.PDF_SELECT_CLASS' | translate) : null"
      >
        <mat-icon>qr_code_2</mat-icon>
        {{ (exportingCards ? 'PARENTS.CARDS_PDF_EXPORTING' : 'PARENTS.PRINT_CARDS') | translate }}
      </button>
      <button
        type="button"
        class="btn btn-secondary"
        (click)="printListPdf()"
        [disabled]="exporting || !selectedClassId || (!selected.length && !filteredItems.length)"
        [attr.title]="!selectedClassId ? ('PARENTS.PDF_SELECT_CLASS' | translate) : null"
      >
        <mat-icon>table_view</mat-icon>
        {{ (exportingList ? 'PARENTS.LIST_PDF_EXPORTING' : 'PARENTS.PRINT_LIST') | translate }}
      </button>
      <button type="button" class="btn btn-primary" *appAccess="'parents:add'" (click)="onAdd()" [disabled]="exporting">
        <mat-icon>add</mat-icon>
        {{ 'PARENTS.ADD' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>

  <section class="summary-grid">
    <button
      type="button"
      class="summary-card"
      [class.active]="statsFilter === 'all'"
      (click)="setStatsFilter('all')"
    >
      <span class="summary-label">{{ 'PARENTS.STATS_ALL' | translate }}</span>
      <strong>{{ statsAllCount }}</strong>
    </button>
    <button
      type="button"
      class="summary-card multi"
      [class.active]="statsFilter === 'multi'"
      (click)="setStatsFilter('multi')"
    >
      <span class="summary-label">{{ 'PARENTS.STATS_MULTI' | translate }}</span>
      <strong>{{ statsMultiCount }}</strong>
    </button>
    <button
      type="button"
      class="summary-card bus"
      [class.active]="statsFilter === 'bus'"
      (click)="setStatsFilter('bus')"
    >
      <span class="summary-label">{{ 'PARENTS.STATS_BUS' | translate }}</span>
      <strong>{{ statsBusCount }}</strong>
    </button>
    <button
      type="button"
      class="summary-card no-bus"
      [class.active]="statsFilter === 'no_bus'"
      (click)="setStatsFilter('no_bus')"
    >
      <span class="summary-label">{{ 'PARENTS.STATS_NO_BUS' | translate }}</span>
      <strong>{{ statsNoBusCount }}</strong>
    </button>
  </section>

  <div class="card">
    <div class="table-toolbar">
      <div class="table-toolbar-left">
        <input type="search" class="search-input" [placeholder]="'PARENTS.SEARCH' | translate"
          [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" />
        <span class="selection-badge" *ngIf="selected.length">
          {{ selected.length }} {{ 'COMMON.SELECTED' | translate }}
        </span>
      </div>
      <div class="table-toolbar-right">
        <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length" (click)="clearSelection()">{{ 'COMMON.CLEAR' | translate }}</button>
        <ng-container *appAccess="'parents:edit'">
          <button type="button" class="btn btn-secondary btn-sm" *ngIf="selected.length === 1" (click)="onEdit()">{{ 'COMMON.EDIT' | translate }}</button>
        </ng-container>
        <ng-container *appAccess="'parents:delete'">
          <button type="button" class="btn btn-danger btn-sm" *ngIf="selected.length" (click)="onDeleteMany()">{{ 'COMMON.DELETE' | translate }}</button>
        </ng-container>
      </div>
    </div>

    <div class="table-scroll">
      <table class="data-table" *ngIf="paginatedItems.length; else emptyParents">
        <thead>
          <tr>
            <th style="width: 44px;"></th>
            <th>{{ 'PARENTS.NAME' | translate }}</th>
            <th>{{ 'PARENTS.PHONES' | translate }}</th>
            <th>{{ 'PARENTS.STUDENTS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of paginatedItems"
            class="clickable"
            [class.selected]="isSelected(item)"
            (click)="openDetails(item)"
          >
            <td><input type="checkbox" [checked]="isSelected(item)" (change)="toggleSelection(item, $event)" /></td>
            <td>{{ displayName(item) }}</td>
            <td>{{ item.phones?.[0]?.value || '—' }}</td>
            <td class="students-cell">{{ studentsSummary(item) }}</td>
          </tr>
        </tbody>
      </table>
      <ng-template #emptyParents><div class="empty-state">{{ 'PARENTS.EMPTY' | translate }}</div></ng-template>
    </div>

    <div class="table-footer">
      <div class="paginator">
        <span>{{ 'COMMON.ROWS_PER_PAGE' | translate }}</span>
        <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [ngValue]="size">{{ size }}</option>
        </select>
        <span>{{ pageStart }}–{{ pageEnd }} {{ 'COMMON.OF' | translate }} {{ filteredItems.length }}</span>
      </div>
      <div class="page-actions">
        <button type="button" class="btn btn-secondary btn-sm" (click)="previousPage()" [disabled]="pageIndex === 0">{{ 'COMMON.PREVIOUS' | translate }}</button>
        <button type="button" class="btn btn-secondary btn-sm" (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">{{ 'COMMON.NEXT' | translate }}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="showDeleteModal">
  <div class="modal-panel" role="dialog" aria-modal="true">
    <div class="modal-header"><h3>{{ 'COMMON.CONFIRM_DELETE' | translate }}</h3></div>
    <div class="modal-body"><p>{{ deleteModalBody | translate: deleteModalParams }}</p></div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onDeleteConfirm(false)">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="button" class="btn btn-danger" (click)="onDeleteConfirm(true)">{{ 'COMMON.DELETE' | translate }}</button>
    </div>
  </div>
</div>

<div class="modal-backdrop" *ngIf="open">
  <div class="modal-panel modal-wide" role="dialog" aria-modal="true">
    <div class="modal-header">
      <h3>{{ (mode === 'edit' ? 'PARENTS.EDIT_TITLE' : 'PARENTS.ADD_TITLE') | translate }}</h3>
      <button type="button" class="btn btn-ghost btn-icon" (click)="closeModal()"><mat-icon>close</mat-icon></button>
    </div>
    <div class="modal-body">
      <div class="alert alert-error" *ngIf="isError">{{ errorMessage | translate }}</div>
      <form [formGroup]="form">
        <div class="form-grid">
          <div class="form-field"><label>{{ 'STUDENTS.FIRST_NAME_AR' | translate }}</label><input formControlName="firstNameAr" /></div>
          <div class="form-field"><label>{{ 'STUDENTS.LAST_NAME_AR' | translate }}</label><input formControlName="lastNameAr" /></div>
          <div class="form-field"><label>{{ 'STUDENTS.FIRST_NAME_EN' | translate }}</label><input formControlName="firstNameEn" /></div>
          <div class="form-field"><label>{{ 'STUDENTS.LAST_NAME_EN' | translate }}</label><input formControlName="lastNameEn" /></div>
          <div class="form-field form-field-qr" *ngIf="mode === 'edit' && qrDataUrl">
            <label>{{ 'PARENTS.QR_CODE' | translate }}</label>
            <div class="qr-preview">
              <img [src]="qrDataUrl" [alt]="'PARENTS.QR_CODE' | translate" />
              <code>{{ qrCode }}</code>
              <span class="field-hint">{{ 'PARENTS.QR_CODE_HINT' | translate }}</span>
            </div>
          </div>
        </div>

        <div class="section-header-row">
          <div>
            <h4>{{ 'PARENTS.SECTION_STUDENTS' | translate }}</h4>
            <p class="section-hint">{{ 'PARENTS.SECTION_STUDENTS_HINT' | translate }}</p>
          </div>
          <button type="button" class="btn btn-secondary btn-sm" (click)="addStudentLink()">
            <mat-icon>add</mat-icon>
            {{ 'PARENTS.ADD_STUDENT' | translate }}
          </button>
        </div>

        <div class="link-list" *ngIf="studentLinks.length; else noStudents">
          <div class="link-row" *ngFor="let link of studentLinks.controls; let i = index" [formGroup]="$any(link)">
            <span class="link-index">{{ i + 1 }}</span>
            <div class="form-field">
              <label>{{ 'PARENTS.SELECT_STUDENT' | translate }}</label>
              <app-searchable-select
                formControlName="student"
                [options]="studentOptions"
                [placeholder]="('PARENTS.SELECT_STUDENT' | translate)"
                [emptyLabel]="('PARENTS.SELECT_STUDENT' | translate)"
                [searchPlaceholder]="searchPlaceholder"
              ></app-searchable-select>
            </div>
            <div class="form-field">
              <label>{{ 'STUDENTS.PARENT_RELATION' | translate }}</label>
              <app-searchable-select
                formControlName="relation"
                [options]="relationOptions"
                [allowEmpty]="false"
                [searchPlaceholder]="searchPlaceholder"
              ></app-searchable-select>
            </div>
            <label class="checkbox-pill">
              <input type="checkbox" formControlName="isPrimaryEmergency" />
              <span>{{ 'STUDENTS.PRIMARY_EMERGENCY' | translate }}</span>
            </label>
            <button type="button" class="btn btn-ghost btn-icon" (click)="removeStudentLink(i)" [attr.aria-label]="'COMMON.DELETE' | translate">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
        <ng-template #noStudents>
          <div class="entries-empty">
            <mat-icon>school</mat-icon>
            <strong>{{ 'PARENTS.NO_STUDENTS' | translate }}</strong>
            <button type="button" class="btn btn-secondary btn-sm" (click)="addStudentLink()">
              <mat-icon>add</mat-icon>
              {{ 'PARENTS.ADD_STUDENT' | translate }}
            </button>
          </div>
        </ng-template>

        <div class="section-header-row">
          <h4>{{ 'STUDENTS.SECTION_PHONES' | translate }}</h4>
          <button type="button" class="btn btn-secondary btn-sm" (click)="addPhone()">{{ 'STUDENTS.ADD_PHONE' | translate }}</button>
        </div>
        <div class="repeat-row" *ngFor="let phone of phones.controls; let i = index" [formGroup]="$any(phone)">
          <input formControlName="value" />
          <select formControlName="label">
            <option *ngFor="let label of contactLabels" [value]="label">{{ ('STUDENTS.LABEL_' + (label | uppercase)) | translate }}</option>
          </select>
          <button type="button" class="btn btn-ghost btn-icon" (click)="removePhone(i)"><mat-icon>delete</mat-icon></button>
        </div>
        <div class="section-header-row">
          <h4>{{ 'STUDENTS.SECTION_EMAILS' | translate }}</h4>
          <button type="button" class="btn btn-secondary btn-sm" (click)="addEmail()">{{ 'STUDENTS.ADD_EMAIL' | translate }}</button>
        </div>
        <div class="repeat-row" *ngFor="let email of emails.controls; let i = index" [formGroup]="$any(email)">
          <input formControlName="value" />
          <select formControlName="label">
            <option *ngFor="let label of contactLabels" [value]="label">{{ ('STUDENTS.LABEL_' + (label | uppercase)) | translate }}</option>
          </select>
          <button type="button" class="btn btn-ghost btn-icon" (click)="removeEmail(i)"><mat-icon>delete</mat-icon></button>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ 'COMMON.CANCEL' | translate }}</button>
      <button type="button" class="btn btn-primary" (click)="submit()">{{ 'COMMON.SAVE' | translate }}</button>
    </div>
  </div>
</div>
